export default {
    url: '/edit/:id?',
    template: '<user-skill-edit-skill/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/edit/skill/index.js